import { __decorate, __metadata, __param } from "tslib";
import _, { isEmpty, map, startsWith, omitBy, isUndefined, includes } from 'lodash';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { AsyncCancelError } from '@/utils/exception';
import { EChargeMode } from '@/constants/companyBase';
export var E_PRIVILEGE_MODIFY;
(function (E_PRIVILEGE_MODIFY) {
    E_PRIVILEGE_MODIFY["NoChange"] = "NoChange";
    E_PRIVILEGE_MODIFY["Add"] = "Add";
    E_PRIVILEGE_MODIFY["Delete"] = "Delete";
})(E_PRIVILEGE_MODIFY || (E_PRIVILEGE_MODIFY = {}));
export class BulkHandleConfig {
    constructor() {
        this.title = '';
        this.canEditEmail = false;
        this.successToast = '';
        this.canModifyPrivileges = false;
        this.canModifyRole = false;
        this.canModifyAccountStatus = false;
        this.canModifyIpLogin = false;
        this.switchPrivilege = false;
        this.companyPrivileges = [];
        this.seatList = [];
        this.hasSeats = false;
        /*
         * 公司是否开启域名限制
         */
        this.companyDomainRestriction = false;
        this.requestTaskName = '';
        this.privilegesModifyOptions = [
            E_PRIVILEGE_MODIFY.NoChange,
            E_PRIVILEGE_MODIFY.Add,
            E_PRIVILEGE_MODIFY.Delete
        ];
    }
}
const INVALID_DATE_START = 'Invalid';
/**
 * 用户可批量编辑、批量分配的最大值
 */
export const MAX_OPERATE_USER = 100;
let AccountBulkAssignEditService = class AccountBulkAssignEditService {
    constructor(packageApi, accountApi, privilegeDataService, boHelperService, companyOrganizationCommonService, vm) {
        this.packageApi = packageApi;
        this.accountApi = accountApi;
        this.privilegeDataService = privilegeDataService;
        this.boHelperService = boHelperService;
        this.companyOrganizationCommonService = companyOrganizationCommonService;
        this.vm = vm;
        this.emails = [];
        this.tenantUserIds = [];
        this.privilegesModifyOptions = [
            E_PRIVILEGE_MODIFY.NoChange,
            E_PRIVILEGE_MODIFY.Add,
            E_PRIVILEGE_MODIFY.Delete
        ];
    }
    set checkedEmails(selectedRows) {
        this.emails = map(_.filter(selectedRows, f => f.email || f.mobile_number), item => item.email || item.mobile_number);
    }
    get checkedEmails() {
        return this.emails;
    }
    set checkedTenantUserIds(selectedRows) {
        this.tenantUserIds = map(_.filter(selectedRows, f => !f.email && !f.mobile_number), item => item.id);
    }
    get checkedTenantUserIds() {
        return this.tenantUserIds;
    }
    postBatchAssignUsers(params) {
        return this.packageApi.postBatchAssignUsers(params);
    }
    patchAccountsBatchEdit(params) {
        return this.accountApi.patchAccountsBatchEdit(params);
    }
    showIpAssignCheckDialog(vm, params) {
        const { ip_restrict_emails } = params;
        if (isEmpty(ip_restrict_emails)) {
            return true;
        }
        const getEmails = '<br>' + map(ip_restrict_emails, email => `${email}`).join('、');
        const title = vm.$t('backoffice.company_users.bulkModifyIpLimitTitle');
        const messages = vm.$t('backoffice.company_users.bulkModifyIpLimitContent');
        return vm.$swal({
            title: title,
            html: messages + getEmails,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('backoffice.common.yes'),
            cancelButtonText: vm.$t('backoffice.common.no'),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
        }).then(res => res.value);
    }
    showPackageAssignCheckDialog(vm, params) {
        const { fake_active_emails, domain_invalid_emails, } = params;
        const domain_restriction = this.companyInfo ? this.companyInfo.domain_restriction : false;
        const getEmails = (emails) => {
            return '<br>' + map(emails, email => `${email}`).join('、');
        };
        const title = vm.$t('backoffice.company.batchAssignCheckTitle');
        const messages = [];
        if (!isEmpty(domain_invalid_emails)) {
            if (domain_restriction) {
                const str = vm.$t('backoffice.company_users.batchAssignFailedDomainRestrictionOn');
                messages.push(str + getEmails(domain_invalid_emails));
            }
            else {
                const str = vm.$t('backoffice.company_users.batchAssignFailedDomainRestrictionOff');
                messages.push(str + getEmails(domain_invalid_emails));
            }
        }
        if (!isEmpty(fake_active_emails)) {
            const str = vm.$t('backoffice.company.batchAssignCheckActive');
            messages.push(str + getEmails(fake_active_emails));
        }
        if (isEmpty(messages)) {
            return Promise.resolve(true);
        }
        return vm.$swal({
            title: title,
            html: messages.join('<br>'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('backoffice.common.yes'),
            cancelButtonText: vm.$t('backoffice.common.no'),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
        }).then(res => res.value);
    }
    getCompanyPrivilege(companyId, charge_mode) {
        const companyPrivilege = this.packageApi.getCompanyPrivilege(companyId);
        const userCanUseChargetModes = this.companyOrganizationCommonService.getCanAssignPackageChargeModes();
        return Promise.all([companyPrivilege, userCanUseChargetModes])
            .then(([companyPrivilege, userCanUseChargetModes]) => {
            return _.flatMap(this.privilegeDataService.getPrivilegeList(companyPrivilege), item => {
                const privilege_charge_mode = _.get(item, 'privilegeList[0].charge_mode');
                if (charge_mode && privilege_charge_mode !== charge_mode) {
                    return [];
                }
                const business_package_enabled = _.some(item.privilegeList, p => p.business_package_enabled);
                const { seatList, hasSeats } = this.getSeat(item);
                const canUse = this.companyOrganizationCommonService.canUsePrivilege(item, userCanUseChargetModes);
                return [{
                        selectType: E_PRIVILEGE_MODIFY.NoChange,
                        switch: false,
                        company_privilege_id: item.company_privilege_id,
                        mainPackages: item.mainPackages,
                        subPackages: item.subPackages,
                        packageVoList: item.packageVoList,
                        duration: item.duration,
                        durationList: item.durationList,
                        privilegeList: item.privilegeList,
                        business_package_enabled,
                        seatList,
                        hasSeats,
                        canAssign: this.canAssign({ canUse, ...item }),
                        canUse: canUse,
                        isAnonymousPrivilege: item.isAnonymousPrivilege,
                    }];
            });
        });
    }
    /**
     * 获取席位数
     */
    getSeat(item) {
        const seatList = [];
        let hasSeats = false;
        if (item.durationList && item.durationList.length) {
            _.map(item.durationList, (el) => {
                const seat = el.seat || 0;
                const assign = _.isEmpty(el.account_privilege_vo_list) ? 0 : el.account_privilege_vo_list.length;
                const leave = seat - assign;
                const end_at = el.end_at;
                const expired = end_at < new Date().getTime();
                /** 非过期 才展示 */
                if (!expired) {
                    seatList.push({
                        text: `${leave}/${seat}`,
                        leave,
                        seat,
                    });
                    if (leave > 0) {
                        hasSeats = true;
                    }
                }
            });
        }
        return { seatList, hasSeats };
    }
    /**
     * 批量分配应当具备和分配同样的权限
     * 2.数据资源中具备该权限类型才可分配canUsePrivilege()
     * 3.如果订单列表具备内部订单，则具备管理内部订单Service 方可分配，否则不可分配。
     * */
    canAssign(item) {
        const privilegeChargeModes = [];
        _.forEach(item.privilegeList, privilege => {
            privilegeChargeModes.push(privilege.charge_mode);
        });
        // 默认以原有逻辑为主  canUs：true 表示可分配
        if (!item.canUse) {
            return false;
        }
        // 内部订单
        if (includes(privilegeChargeModes, EChargeMode.INTERNAL)) {
            if (!this.vm.$canUseDataResource(EChargeMode.INTERNAL)) {
                // 不具备内部资源不可分配
                return false;
            }
        }
        return true;
    }
    /**
     * 批量分配表单配置
     */
    get bulkAssignFormConfig() {
        const config = new BulkHandleConfig();
        config.title = 'backoffice.company_users.bulkAssign';
        config.successToast = 'backoffice.company_users.batchAssignSuccess';
        config.canModifyPrivileges = true;
        config.requestTaskName = 'bulkAssignFormSubmit';
        return config;
    }
    invalidDateError(timeData) {
        if (timeData && startsWith(timeData.toString(), INVALID_DATE_START)) {
            timeData = undefined;
        }
        return timeData;
    }
    bulkAssignFormSubmit(vm, params) {
        let data = {
            email_set: params.email_set,
            add_privilege_id_set: params.add_privilege_id_set,
            remove_privilege_id_set: params.remove_privilege_id_set,
            begin_at_value: params.begin_at_value,
            end_at_value: params.end_at_value,
            company_id: params.company_id,
            do_check: true,
            country_code: params.country_code,
            tenant_user_ids: params.tenant_user_ids,
        };
        data.begin_at_value = this.invalidDateError(data.begin_at_value);
        data.end_at_value = this.invalidDateError(data.end_at_value);
        data = omitBy(data, isUndefined);
        return this.postBatchAssignUsers(data).then(async (res) => {
            data.do_check = false;
            const result = await this.showPackageAssignCheckDialog(vm, res);
            if (!result) {
                throw new AsyncCancelError();
            }
            return this.postBatchAssignUsers(data);
        });
    }
    /**
     * 新用户表单配置
     */
    get newUserFormConfig() {
        const config = new BulkHandleConfig();
        config.title = 'backoffice.company_users.newUser';
        config.canEditEmail = true;
        config.successToast = 'backoffice.company.table.addSuccess';
        config.canModifyPrivileges = true;
        config.canModifyRole = true;
        config.switchPrivilege = true;
        config.requestTaskName = 'newUserFormSubmit';
        return config;
    }
    newUserFormSubmit(vm, params) {
        let data = {
            email_set: params.email_set,
            add_privilege_id_set: params.add_privilege_id_set,
            remove_privilege_id_set: params.remove_privilege_id_set,
            begin_at_value: params.begin_at_value,
            end_at_value: params.end_at_value,
            company_id: params.company_id,
            user_role: params.user_role,
            country_code: params.country_code,
            do_check: true,
        };
        data.begin_at_value = this.invalidDateError(data.begin_at_value);
        data.end_at_value = this.invalidDateError(data.end_at_value);
        data = omitBy(data, isUndefined);
        return this.postBatchAssignUsers(data).then(async (res) => {
            data.do_check = false;
            const result = await this.showPackageAssignCheckDialog(vm, res);
            if (!result) {
                throw new AsyncCancelError();
            }
            return this.postBatchAssignUsers(data);
        });
    }
    /**
     * 批量编辑表单配置
     */
    get bulkEditFormConfig() {
        const config = new BulkHandleConfig();
        config.title = 'backoffice.company_users.bulkModify';
        config.successToast = 'backoffice.company_users.batchModifyUserSuccess';
        config.canModifyAccountStatus = true;
        config.canModifyIpLogin = true;
        config.canModifyRole = true;
        config.requestTaskName = 'buldEditFormSubmit';
        return config;
    }
    buldEditFormSubmit(vm, params) {
        const data = {
            company_id: params.company_id,
            email_set: params.email_set,
            ip_restrict: params.ip_restrict,
            user_role: params.user_role,
            account_status: params.account_status,
            country_code: params.country_code,
            do_check: true,
        };
        return this.patchAccountsBatchEdit(data).then(async (res) => {
            data.do_check = false;
            const result = await this.showIpAssignCheckDialog(vm, res);
            if (!result) {
                throw new AsyncCancelError();
            }
            return this.patchAccountsBatchEdit(data);
        });
    }
};
AccountBulkAssignEditService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PackageApi)),
    __param(1, inject(Symbols.AccountApi)),
    __param(2, inject(Symbols.PrivilegeDataService)),
    __param(3, inject(Symbols.BoHelperService)),
    __param(4, inject(Symbols.CompanyOrganizationCommonService)),
    __param(5, inject(Symbols.Vue)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], AccountBulkAssignEditService);
export { AccountBulkAssignEditService };
